import { SCALE, TILE_SIZE } from '../../utils/constants'
import * as Controller from '../Controller/Controller'
import Arrow from '../DialogArrow'
import UI from '../UI'

class DialogOptions {
  constructor(scene) {
    this.scene = scene
    this.options = []
    this.menuOptionsContainer = null
    this.keyDownHandler = this.keyDownHandler.bind(this)
  }

  mount() {
    this.menuOptionsContainer = this.scene.add.container(0,0)
    this.menuOptionsContainer.setScrollFactor(0)
    this.currentSlot = 0
    this.scene.input.keyboard.on("keydown", this.keyDownHandler)
  }
  
  unmount() {
    this.scene.input.keyboard.off("keydown", this.keyDownHandler)
    this.menuOptionsContainer.destroy()
    this.arrow?.setVisible(false)
    this.arrow = null
  }

  get visible() {
    return this.menuOptionsContainer.visible
  }

  show(options = {}) {
    this.menuOptionsContainer.setVisible(true)
    this.options = Object.keys(options).reduce((r, k) => {
      if(options[k] !== null) {
        r[k] = options[k]
      }
      return r
    }, {})
    const firstNonEmptySlotKey = Object.keys(this.options).sort()[0]
    this.currentSlot = this.options[firstNonEmptySlotKey].slot
    
    this.menuOptionsContainer.depth = 20
    this.menuOptionsContainer.setPosition(
      UI.tileToScreen(4.5),
      UI.tileToScreen(9),
    )
    const drawOption = (label = '', slot = 0) => {
      const x = UI.tileToScreen(slot === 0 || slot === 1 ? 0 : 9)
      const y = UI.tileToScreen(slot === 0 || slot === 2 ? 0.25 : 1)
      const textObj = this.scene.add.text(
        x,
        y,
        label,
        {
          fontFamily: 'GameGirl',
          fontSize: "8px",
          fill: "#ffffff",
          lineSpacing: 2
        }
      )
      textObj.setScale(SCALE)
      textObj.displayHeight = UI.pixelToScreen(8)
      textObj.displayWidth = UI.pixelToScreen(8 * label.length)
      textObj.setShadow(-1,1)
      this.menuOptionsContainer.add(textObj)
    }
    Object.values(this.options).forEach(o => drawOption(o.label, o.slot))
    // drawOption("YES", 0)
    // drawOption("NO", 1)
    // drawOption("CLOSE", 2)
    // drawOption("STORY", 3)
    
    if(!this.arrow) {
      this.arrow = new Arrow(this.scene).getArrowRight();
      this.arrow.name = 'menu_arrow'
      this.arrow.setSize(UI.tileToPixels(0.66), UI.tileToPixels(0.66))
    }
    this.setArrowPositionBySlot(this.currentSlot)
    // hide if no option
    this.arrow.setVisible(this.options.length !== 0)

  }
  hide() {
    while(this.menuOptionsContainer?.list.length) {
      this.menuOptionsContainer?.list?.forEach(ch => ch.destroy())
    }
    // this.menuOptionsContainer?.list?.forEach((ch, idx) => ch.type !== 'Graphics' ? ch.destroy() : null)
    this.menuOptionsContainer.setVisible(false)
    this.arrow?.setVisible(false)
  }

  keyDownHandler(event) {
    if(!this.menuOptionsContainer.visible) { return }
    let slot = this.currentSlot
    if (Controller.isUp( event.key) && (slot === 1 || slot === 3)) {
      const newSlotIdx = slot - 1
      if (this.options[`slot${newSlotIdx}`]) {
        this.currentSlot = newSlotIdx
      }
    }
    if (Controller.isLeft(event.key)) {
      const newSlotIdx = slot - 2
      if (this.options[`slot${newSlotIdx}`]) {
        this.currentSlot = newSlotIdx
      } else if(this.options[`slot${newSlotIdx - 1}`]) {
        this.currentSlot = newSlotIdx - 1
      }
    }
    if (Controller.isRight(event.key)) {
      const newSlotIdx = slot + 2
      if (this.options[`slot${newSlotIdx}`]) {
        this.currentSlot = newSlotIdx
      } else if(this.options[`slot${newSlotIdx + 1}`]) {
        this.currentSlot = newSlotIdx + 1
      }
    }
    if (Controller.isDown(event.key) && (slot === 0 || slot === 2)) {
      const newSlotIdx = slot + 1
      if (this.options[`slot${newSlotIdx}`]) {
        this.currentSlot = newSlotIdx
      }
    }

    if(Controller.isConfirm(event.key)) {
      const selectedOption = Object.values(this.options).find(o => o.slot === this.currentSlot)
      selectedOption?.onSelect()
    } else {
      this.setArrowPositionBySlot(this.currentSlot)
    }
  }

  setArrowPositionBySlot(slot) {
    const ARROW_OFFSET_X = -UI.tileToScreen(0.5)
    const ARROW_OFFSET_Y = -UI.tileToScreen(0.4)
    const x = UI.tileToScreen(slot === 0 || slot === 1 ? 0 : 9)
    const y = UI.tileToScreen(slot === 0 || slot === 2 ? 0.25 : 1)

    this.arrow.tilemapLayer.setPosition(
      x + ARROW_OFFSET_X + this.menuOptionsContainer.x,
      y + ARROW_OFFSET_Y + this.menuOptionsContainer.y
    )
  }
}

export default DialogOptions
